import React from 'react';
interface TimePickerProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}
export function TimePicker({
  label,
  value,
  onChange,
  error
}: TimePickerProps) {
  return <div className="w-full" data-id="element-341">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-342">
          {label}
        </label>}
      <input type="time" value={value} onChange={e => onChange(e.target.value)} className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${error ? 'border-red-500' : 'border-gray-300'}`} data-id="element-343" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-344">{error}</p>}
    </div>;
}